import PredefinedRoute from "../Models/PredefinedRoute";
import HttpService from "../Services/HttpService";
import AddPredefinedRouteRequest from "../Requests/PredefinedRoutes/AddPredefinedRouteRequest";
import UpdatePredefinedRouteRequest from "../Requests/PredefinedRoutes/UpdatePredefinedRouteRequest";

class PredefinedRouteRepository
{
  public predefinedRoutes: PredefinedRoute[] = [];

  public async load(): Promise<PredefinedRoute[]>
  {
    const url = '/PredefinedRoute';
    this.predefinedRoutes = await HttpService.get<PredefinedRoute[]>(url);
    return this.predefinedRoutes;
  }

  public async add(predefinedRoute: PredefinedRoute): Promise<void>
  {
    const url = '/PredefinedRoute';
    const request: AddPredefinedRouteRequest = {
      groupId: predefinedRoute.group.id,
      anyOrder: predefinedRoute.anyOrder,
      route: predefinedRoute.route.map(x => { return { index: x.index, cubeId: x.cube.id }; }),
    };
    await HttpService.post<PredefinedRoute>(url, request);
    await this.load();
  }

  public async update(predefinedRoute: PredefinedRoute): Promise<void>
  {
    const url = '/PredefinedRoute';
    const request: UpdatePredefinedRouteRequest = {
      id: predefinedRoute.id,
      groupId: predefinedRoute.group.id,
      anyOrder: predefinedRoute.anyOrder,
      route: predefinedRoute.route.map(x => { return { index: x.index, cubeId: x.cube.id }; }),
    };
    await HttpService.put<PredefinedRoute>(url, request);
    await this.load();
  }

  public async delete(predefinedRoute: PredefinedRoute): Promise<void>
  {
    const url = `/PredefinedRoute/${predefinedRoute.id}`;
    await HttpService.delete<void>(url);
    await this.load();
  }

  public getById(id: string): PredefinedRoute | undefined
  {
    return this.predefinedRoutes
      .find((predefinedRoute: PredefinedRoute) => predefinedRoute.id === id);
  }

  public getByGroupId(id: string): PredefinedRoute | undefined
  {
    return this.predefinedRoutes
      .find((x: PredefinedRoute) => x.group.id === id);
  }
}

export const predefinedRouteRepository = new PredefinedRouteRepository();